import React from 'react'
import { H6, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import RedactionButton from './RedactionButton'

export default function RedactionSection() {
  const [t] = useTranslation()
  return (
    <div>
      <H6>{t('shared-image-viewer.redaction.section-title', 'Redaction Editor')}</H6>
      <Paragraph size="sm">
        {t('shared-image-viewer.redaction.section-info', 'Add, adjust, or remove redaction areas on this image.')}
      </Paragraph>
      <Separator size="xs" />
      <RedactionButton />
      <Separator size="xs" />
    </div>
  )
}
